import { useQuery } from '@tanstack/react-query';

import { getArticle } from 'api/articles';
import { articleKeys } from 'api/queryKeys';

import { transformArticleResponse } from 'transformers/article';

export const useArticleQuery = (articleId: string | undefined) =>
    useQuery({
        queryKey: articleKeys.detail(articleId || ''),
        queryFn: () => getArticle(articleId),
        select: transformArticleResponse,
        enabled: Boolean(articleId),
    });
